import V2CatalogScheduleDialog from '@/components/v2/catalog/dialogs/V2CatalogScheduleDialog.vue';
import { useModal } from '@/composition/use-modal';
import type { IScheduleDialogResult } from '@/domain/catalog/schedule-form';
import { ISimpleHourRange } from '@/interfaces/ISimpleHourRange';

/** Distinct modal names: two dialogs open at once must not hide each other. */
let sequence = 0;

/** Opens «Horarios» (plan §5.14). Call at the top of `setup`. */
export function useScheduleDialog() {
  const modals = useModal();

  /** The new rows, or null when cancelled. */
  async function openSchedule(input: {
    name: string;
    hourRanges: ISimpleHourRange[] | null;
    entity: 'item' | 'category';
  }): Promise<IScheduleDialogResult | null> {
    sequence += 1;
    const dialogName = `catalog-schedule-${sequence}`;
    const result = await modals.showDynamicDialog<IScheduleDialogResult | null>(
      V2CatalogScheduleDialog,
      { ...input, dialogName },
      dialogName,
      {
        adaptive: true,
        width: 560,
        maxWidth: window.innerWidth * 0.95,
        height: 'auto',
        scrollable: true,
        clickToClose: false,
      }
    );
    return result ?? null;
  }

  return { openSchedule };
}
